import { render, staticRenderFns } from "./toStudy.vue?vue&type=template&id=64b0f448&scoped=true&"
import script from "./toStudy.vue?vue&type=script&lang=js&"
export * from "./toStudy.vue?vue&type=script&lang=js&"
import style0 from "./toStudy.vue?vue&type=style&index=0&id=64b0f448&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b0f448",
  null
  
)

export default component.exports